import { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import DataPathContext from '../components/DataPathContext';
import * as DataActions from '../store/data/actions';
export const useDataActions = (path, detachedId)=>{
    const ctx = useContext(DataPathContext);
    const dispatch = useDispatch();
    const p = path || ctx.path;
    const dId = detachedId === undefined ? ctx.detachedId : detachedId;
    return useMemo(()=>{
        return {
            updateRow: (callback, options)=>dispatch(DataActions.updateRow(p, callback, {
                    ...options,
                    detachedId: dId || undefined
                })),
            removeRow: (options)=>dispatch(DataActions.removeRow(p, {
                    ...options,
                    detachedId: dId || undefined
                }))
        };
    }, [
        dispatch,
        p,
        dId
    ]);
};
